<template>
	<div
		class="preloader"
		:style="{
			backgroundImage: primaryBackground
				? `url(${primaryBackground})`
				: undefined,
			backgroundRepeat: primaryBackground ? 'no-repeat' : undefined,
			backgroundPosition: primaryBackground ? '0 0' : undefined,
			backgroundSize: primaryBackground ? 'cover' : undefined,
		}"
	>
		<Loader />
	</div>
</template>

<script>
import Loader from './Loader.vue'
export default {
	name: 'preloader',
	components: {
		Loader,
	},
	computed: {
		primaryBackground() {
			return this.$store.getters.primaryBackground
		},
	},
}
</script>

<style lang="scss" scoped>
.preloader {
	position: fixed;
	z-index: 10000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff url(~@/assets/back-white.png) center 0 no-repeat;
}
</style>
